import { createContext, useContext, useState, useEffect } from 'react';
import { getPublicSettings } from '@/lib/api';

const SettingsContext = createContext({});

export function SettingsProvider({ children }) {
    const [settings, setSettings] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getPublicSettings()
            .then(res => setSettings(res.data))
            .catch(err => console.error('Failed to load settings:', err))
            .finally(() => setLoading(false));
    }, []);

    return (
        <SettingsContext.Provider value={{ settings, loading, setSettings }}>
            {children}
        </SettingsContext.Provider>
    );
}

export function useSettings() {
    return useContext(SettingsContext);
}
